import Vue from "vue";
import { checkResponse } from "@/helpers/store";
import { nameFirme, kindName, userName, rCount } from "@/helpers/reference";

const state = {
  relationshipFilter: {
    period: {
      enabled: false,
      dateBegin: "",
      dateEnd: ""
    },
    organization: {
      enabled: false,
      code: null
    },
    payment: {
      enabled: false,
      code: null
    },
    sum: {
      enabled: false,
      sumBegin: null,
      sumEnd: null
    }
  },
  relationshipCompliance: {
    datesDifference: {
      enabled: false,
      days: ""
    },
    organizationsMatch: {
      enabled: false
    },
    paymentMethodsMatch: {
      enabled: false
    },
    amountDifference: {
      enabled: false,
      summa: null
    }
  },
  paymentsRelationship: {
    data: []
  },
  packsRelationship: {
    data: []
  },
  relationshipReloadAllGrids: false,
  postingRelationship: null
};

const mutations = {
  setRelationshipFilter: (state, payload) =>
    (state.relationshipFilter = payload),
  setComplianceFilter: (state, payload) =>
    (state.relationshipCompliance = payload),
  setPaymentsRelationship: (state, payload) =>
    (state.paymentsRelationship = payload),
  clearPaymentsRelationship: state =>
    (state.paymentsRelationship = { data: [] }),
  setPacksRelationship: (state, payload) => (state.packsRelationship = payload),
  clearPacksRelationship: state => (state.packsRelationship = { data: [] }),
  setRelationshipReloadAllGrids: (state, payload) =>
    (state.relationshipReloadAllGrids = payload),
  setPostingRelationship: (state, payload) =>
    (state.postingRelationship = payload)
};

const actions = {
  async getPaymentsRelationship({ commit, state, rootState }) {
    try {
      commit("setLoading", true);
      const filter = state.relationshipFilter;
      let params = {
        script: "web.wbrelformpay",
        funcname: "wbRunSelect",
        dtBegin: `${filter.period.dateBegin}`,
        dtEnd: `${filter.period.dateEnd}`
      };
      if (filter.organization.enabled) {
        params["codefirme"] = filter.organization.code;
      }
      if (filter.payment.enabled) {
        // kindpay not use in filter after 05.04.2020
        params["kindpay"] = filter.payment.code;
      }
      if (filter.sum.enabled) {
        params["sumBegin"] = filter.sum.sumBegin;
        params["sumEnd"] = filter.sum.sumEnd;
      }

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );
      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentsRelationship", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async getPacksRelationship(
    { commit, state, rootState },
    { kindpay, codefirme, datepay, summa }
  ) {
    try {
      commit("setLoading", true);
      const filter = state.relationshipFilter;
      const compliance = state.relationshipCompliance;

      let params = {
        script: "web.wbrelformpack",
        funcname: "wbRunSelect",
        dtBegin: `${filter.period.dateBegin}`,
        dtEnd: `${filter.period.dateEnd}`,
        kindpay: `${kindpay}`,
        codefirme: `${codefirme}`,
        datepay: `${datepay}`,
        summapaysheet: `${summa}`
      };

      if (filter.organization.enabled) {
        params["fcodefirme"] = filter.organization.code;
      }
      if (filter.payment.enabled) {
        params["fkindpay"] = filter.payment.code;
      }
      if (filter.sum.enabled) {
        params["sumBegin"] = filter.sum.sumBegin;
        params["sumEnd"] = filter.sum.sumEnd;
      }

      params["sootdayperiodflag"] = compliance.datesDifference.enabled
        ? "1"
        : "0";
      params["sootdayperiod"] = compliance.datesDifference.days;
      params["sootcodefirmeflag"] = compliance.organizationsMatch.enabled
        ? "1"
        : "0";
      params["sootkindpayflag"] = compliance.paymentMethodsMatch.enabled
        ? "1"
        : "0";
      params["sootsummaflag"] = compliance.amountDifference.enabled ? "1" : "0";
      params["sootsumma"] = compliance.amountDifference.summa;

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );
      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPacksRelationship", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async linkRelationship(
    { commit, rootState },
    { inetpay, paysheetid, transferid, userid, npack, datebeginfact, datebank }
  ) {
    try {
      commit("setFullPageLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wblink",
            funcname: "wbRunLink",
            inetpay: `${inetpay}`,
            paysheetid: `${paysheetid}`,
            transferid: `${transferid}`,
            userid: `${userid}`,
            npack: `${npack}`,
            datebeginfact: `${datebeginfact}`,
            datebank: `${datebank}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setRelationshipReloadAllGrids", true);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async postingRelationship({ commit, rootState }, { npack }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbraznostimeout",
            funcname: "wbraznoskatimeout",
            npack: `${npack}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPostingRelationship", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  relationshipFilter: state => state.relationshipFilter,
  relationshipCompliance: state => state.relationshipCompliance,
  paymentsRelationship: (state, rootState) => {
    let items = [];
    state.paymentsRelationship.data.forEach(item => {
      item["nameaccount"] = rCount(
        rootState.params.account.data,
        item.accountid
      );
      item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      item["kindname"] = kindName(rootState.params.gkindpay.data, item.kindpay);
      items.push(item);
    });
    return items;
  },
  packsRelationship: (state, rootState) => {
    let items = [];
    state.packsRelationship.data.forEach(item => {
      item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      item["kindname"] = kindName(rootState.params.gkindpay.data, item.kindpay);
      item["username"] = userName(rootState.params.gusers.data, item.userid);
      items.push(item);
    });
    return items;
  },
  relationshipReloadAllGrids: state => state.relationshipReloadAllGrids,
  postingRelationship: state => state.postingRelationship
};

export default { state, mutations, actions, getters };
